import appApi from "./api";

export const cotizacionUnidadHistorialService = {
  get() {
    return appApi().post("cotizaciones/unidad/history");
  },

  getById(token) {
    return appApi().get(`public/cotizaciones/unidad/${token}/show`);
  },

  aprobar(token, body) {
    return appApi().put(`public/cotizaciones/unidad/${token}/aprobar`, body);
  },
};
